import type { Project, RootScope } from '../types';
import type { ProjectSearchResult } from '../unit.search.panel/types';
import type { ObjectsNaviPanel as ObjectsNaviPanelType } from './objects.navi.panel.resource';

objectsNaviPanelCtrl.$inject = [
  '$scope',
  '$rootScope',
  '$location',
  'ObjectsNaviPanel',
  '$timeout',
];

interface ScopeProps {
  sectionId: string;
}

export interface objectsNaviPanelCtrl extends ScopeProps {
  isLoaded: boolean;
  publicMode: boolean;
  byHouseMode: boolean;
  objects: Project[] | ProjectSearchResult[];
  objectsOriginal: Project[] | ProjectSearchResult[];

  resetFilter(): void;
}

export function objectsNaviPanelCtrl(
  this: objectsNaviPanelCtrl,
  $scope: angular.IScope,
  $rootScope: RootScope,
  $location: angular.ILocationService,
  ObjectsNaviPanel: ObjectsNaviPanelType,
  $timeout: angular.ITimeoutService,
) {
  const vm = this;
  vm.isLoaded = false;
  vm.objects = [];
  vm.objectsOriginal = [];
  vm.publicMode = $location.absUrl().indexOf('/public') > 0;
  vm.byHouseMode = $location.absUrl().indexOf('/house') > 0;

  const request = {
    sectionId: vm.sectionId,
    ...(vm.publicMode ? { public: true } : {}),
    ...(vm.byHouseMode ? { byHouse: true } : {}),
  };

  const initObjects = () => {
    if ($rootScope.filterObjects) {
      vm.objects = $rootScope.filterObjects.sort(
        (a, b) => Number(b.id) - Number(a.id),
      );
    } else {
      vm.objects = vm.objectsOriginal.slice();
    }
  };

  ObjectsNaviPanel.getObjectNavi(request, function (resp) {
    vm.objectsOriginal = resp.data.sort((a, b) => Number(b.id) - Number(a.id));

    initObjects();

    vm.isLoaded = true;
  });

  $scope.$watch('$root.filterObjects', function () {
    initObjects();
  });

  vm.resetFilter = function () {
    // timeout so event happens not during $apply
    $timeout(function () {
      // call resetQuery() in unit.search.panel.controller.ts
      $rootScope.$broadcast('unit.search.panel:resetFilters');
    }, 100);
  };
}
